<template>
  <div style="padding: 2rem; background: #fff">
    <vxe-toolbar
      v-if="
        operateType === 'add' ||
        operateType === 'edit' ||
        operateType === 'renewal' ||
        operateType === 'changeSubject'
      "
    >
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('spaceTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :footer-method="footerMethod"
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="spaceTableData"
      :edit-config="editConfig"
      size="mini"
      ref="spaceTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="spaceTableEditRules"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column type="seq" width="60" title="行号"></vxe-table-column>
      <vxe-table-column
        field="spaceAreaNo"
        width="150"
        title="片区"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAreaNo"
            clearable
            filterable
            @change="() => handleAreaChange(scope.row, scope, 'spaceTable')"
            :disabled="operateType === 'changeInfo'"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item?.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAreaNo, areaList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAssetNo"
        title="资产名称"
        width="150"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAssetNo"
            clearable
            filterable
            @change="() => handleAssetsChange(scope.row, scope, 'spaceTable')"
            :disabled="operateType === 'changeInfo'"
          >
            <el-option
              v-for="(item, index) in scope.row.assetsList || []"
              :key="index"
              :label="item?.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAssetNo, row.assetsList || [], 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceUnitNo"
        title="单元（楼栋）"
        width="150"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceUnitNo"
            clearable
            filterable
            @change="() => handleUnitChange(scope.row, scope, 'spaceTable')"
            :disabled="operateType === 'changeInfo'"
          >
            <el-option
              v-for="(item, index) in scope.row.unitList || []"
              :key="index"
              :label="item?.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceUnitNo, row.unitList || [], 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceFloorNo"
        title="楼层"
        width="150"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceFloorNo"
            clearable
            filterable
            @change="() => handleFloorChange(scope.row, scope, 'spaceTable')"
            :disabled="operateType === 'changeInfo'"
          >
            <el-option
              v-for="(item, index) in scope.row.spaceFloorList || []"
              :key="index"
              :label="item?.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceFloorNo, row.spaceFloorList || [], 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceRoomNo"
        title="房号"
        width="150"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceRoomNo"
            clearable
            filterable
            @change="() => handleRoomChange(scope.row, scope)"
            :disabled="operateType === 'changeInfo'"
          >
            <el-option
              v-for="(item, index) in scope?.row?.roomList || []"
              :key="index"
              :label="item?.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceRoomNo, row?.roomList || [], 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceArea"
        width="150"
        title="面积"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="'99999999999.99'"
            v-model="scope.row.spaceArea"
            :precision="2"
            :disabled="operateType === 'changeInfo'"
            @input="(val) => handleChargePrice(val, scope.row, scope, 'spaceArea')"
            @change.native="(val) => handleChargePrice(val, scope.row, scope, 'spaceArea')"
          ></input-number>
        </template>
      </vxe-table-column>
      <template v-if="isPropertyContract">
        <vxe-table-column
          field="expenseTypeCode"
          title="费用类型"
          width="150"
          :edit-render="{
            name: 'default',
          }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.expenseTypeCode"
              clearable
              filterable
              :disabled="operateType === 'changeInfo'"
            >
              <el-option
                v-for="(item, index) in dictListMap['RENT_EXPENSE_TYPE'] || []"
                :key="index"
                :label="item?.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelect(
              row.expenseTypeCode,
              dictListMap['RENT_EXPENSE_TYPE'] || [],
              'value',
              'label'
            )
          }}</template>
        </vxe-table-column>
      </template>
      <template v-if="currChargeMethods === '01' && isPropertyContract">
        <vxe-table-column
          field="chargeMethod"
          title="计费方式"
          width="150"
          :edit-render="{
            name: 'default',
          }"
        >
          <template v-slot:edit="scope">
            <el-select
              v-model="scope.row.chargeMethod"
              clearable
              filterable
              @change="() => handleChargeMethods(scope.row, scope, 'spaceTable')"
            >
              <el-option
                v-for="(item, index) in spaceChargeMethodList"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelect(row.chargeMethod, spaceChargeMethodList)
          }}</template>
        </vxe-table-column>
        <vxe-table-column field="measurementUnit" width="150" title="计量单位">
          <template v-slot:edit="scope">
            <el-select v-model="scope.row.measurementUnit" clearable filterable>
              <el-option
                v-for="(item, index) in productUnitList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{ row.chargeMethod ? '月' : '' }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="chargeCycle"
          title="计费周期"
          width="150"
          :edit-render="{
            name: 'default',
          }"
        >
          <template v-slot:edit="scope">
            <el-select v-model="scope.row.chargeCycle" clearable filterable>
              <el-option
                v-for="(item, index) in chargeCycleList"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelect(row.chargeCycle, chargeCycleList)
          }}</template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="chargeUnitPrice"
          title="计费单价"
          width="150"
          :edit-render="{ name: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              :max="'99999999999.99'"
              v-model="scope.row.chargeUnitPrice"
              :precision="3"
              @input="(val) => handleChargePrice(val, scope.row, scope, 'chargeUnitPrice')"
            ></input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="chargePrice"
          title="计费金额（元/月）"
          width="150"
          :edit-render="{ name: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              :max="'99999999999.99'"
              v-model="scope.row.chargePrice"
              :precision="3"
            ></input-number>
          </template>
        </vxe-table-column> -->
        <!-- 价格合计 -->
        <vxe-table-column field="priceSetting" title="价格设置" width="120">
          <template #default="scope">
            <el-button type="text" @click="() => priceSettingRowHandler(scope.row)">{{
              operateType === 'detail' || operateType === 'audit'
                ? '查看'
                : scope.row.spaceDetails?.length > 0
                ? '修改'
                : '新增'
            }}</el-button>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="firstSettlementDate"
          title="首次结算日期"
          width="150"
          :edit-render="{ name: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              v-model="scope.row.firstSettlementDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 120px"
              placeholder=""
              :picker-options="pickerSettleOptions"
            >
            </el-date-picker>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="annualGrowthRate"
          title="年增长比例"
          width="150"
          :edit-render="{ name: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              :max="'999.99'"
              v-model="scope.row.annualGrowthRate"
              :precision="2"
            ></input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isShowRentAmount" field="rentAmount" title="租金" width="150">
          <template #default="{ row }">
            <span>{{ row.rentAmount ? parseFloat(row.rentAmount).toFixed(2) : '' }}</span>
          </template>
          <template v-slot:edit="scope">
            <input-number
              :max="'99999999999.99'"
              v-model="scope.row.rentAmount"
              :precision="2"
            ></input-number>
          </template>
        </vxe-table-column>
        <vxe-table-column field="operation" title="免租期设置" width="120">
          <template #default="scope">
            <el-button type="text" @click="() => settleRentFreeRowHandler(scope.row)">{{
              operateType === 'detail' || operateType === 'audit' ? '查看' : '设置'
            }}</el-button>
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <!-- 免租期设置 -->
    <SettleRentFreeDialog
      ref="settleRentFreeDialogRef"
      :isDisabled="operateType === 'detail' || operateType === 'audit'"
      @submit="settleRendFreeSubmitHandler"
      freeInfos="leaseContractFreeRents"
    />
    <!-- 价格设置 -->
    <PriceSetDialog
      ref="priceSetDialogRef"
      :isDisabled="operateType === 'detail' || operateType === 'audit'"
      :startDate="startDate"
      :endDate="endDate"
      :isShowPriceList="isShowPriceList"
      @submit="priceChangeConfirm"
    ></PriceSetDialog>
  </div>
</template>

<script>
  // TODO 计算租金逻辑
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import { leaseSpaceChargeMethodList, productUnitList, chargeCycleList } from '../data';
  import SettleRentFreeDialog from './SettleRentFreeDialog';
  import PriceSetDialog from './PriceSetDialog';
  export default {
    name: 'spaceInfo',
    props: [
      'leaseDateFrom',
      'leaseDateUntil',
      'detailSpaceChargeMethod',
      'detailSpaceTableData',
      'contractCategory',
    ],
    mixins: [leaseContractMixin],
    data() {
      return {
        spaceTableData: [],
        editConfig: {},
        currChargeMethods: '',
        spaceChargeMethodList: leaseSpaceChargeMethodList,
        productUnitList,
        chargeCycleList,
        startDate: '',
        endDate: '',
        currSpaceId: '',
        currRentMonth: '',
        isShowRentAmount: false,
        isPropertyContract: true,
        isShowPriceList: false,
      };
    },
    created() {
      this.getArea();
      // if (this.operateType !== 'add') {
      //   this.dealDetailData();
      // }
      if (this.$route.query.type == 'detail') {
        this.currChargeMethods = '01';
      }
    },
    watch: {
      contractCategory(val) {
        console.log('====', val);
        if (val == '02') {
          //物业合同
          this.isPropertyContract = false;
        }
        if (val == '01') {
          this.isPropertyContract = true;
        }
        console.log('isPropertyContract监听', this.isPropertyContract);
      },
      detailSpaceChargeMethod(newVal) {
        this.currChargeMethods = newVal;
      },
      detailSpaceTableData(newVal) {
        if (newVal) {
          this.dealDetailData(newVal);
        }
      },
      leaseDateFrom(newVal) {
        this.startDate = newVal;
      },
      leaseDateUntil(newVal) {
        console.log(newVal, '1234');
        this.endDate = newVal;
      },
    },
    mounted() {
      this.editConfig =
        this.operateType === 'add' ||
        this.operateType === 'edit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeSubject' ||
        this.operateType === 'changeInfo'
          ? { trigger: 'dblclick', mode: 'row' }
          : {};
      if (['detail', 'audit'].includes(this.operateType)) {
        this.isShowRentAmount = true;
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      operateType() {
        return this.$route.query.type;
      },
      spaceTableEditRules() {
        return {
          spaceAreaNo: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          spaceAssetNo: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          spaceArea: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请填写',
              trigger: 'blur',
            },
          ],
          chargeMethod: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          measurementUnit: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          chargeUnitPrice: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur',
            },
          ],
          chargePrice: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur',
            },
          ],
          chargeCycle: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          expenseTypeCode: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
        };
      },
      pickerSettleOptions() {
        return {
          disabledDate: (time) => {
            return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
          },
        };
      },
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['spaceArea'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.spaceArea, 0).toFixed(3);
            }
            if (['rentAmount'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.rentAmount, 0).toFixed(2);
            }
            if (['chargePrice'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.chargePrice, 0).toFixed(3);
            }
            // 价格合计
            if (['priceSetting'].includes(column.property)) {
              let sum = '';
              let nowTime = moment(new Date()).format('YYYY-MM-DD');
              data.forEach((item) => {
                item.spaceDetails.forEach((info, index) => {
                  // 价格合计取当前时间所在区间的价格进行计算，如果超出期限，按照最后的区间价格进行合计
                  if (
                    (nowTime >= info.leaseDateFrom && nowTime <= info.leaseDateUntil) ||
                    (index == item.spaceDetails.length - 1 && nowTime > info.leaseDateUntil) ||
                    (nowTime < info.leaseDateFrom && index == 0)
                  ) {
                    sum = (sum - 0 + (info.chargePrice - 0)).toFixed(3);
                  }
                });
              });
              return sum;
            }
            return null;
          }),
        ];
      },
      priceChangeConfirm(res) {
        console.log(res, '提交后的数据，需要替换当前编辑的行');
        const tableDataList = this.$refs.spaceTable.getTableData().fullData || [];
        const currentIndex = tableDataList.findIndex((item) => item._XID == res._XID);
        tableDataList.splice(currentIndex, 1, res);
        this.isShowPriceList = true;
        this.spaceTableData = tableDataList;
      },
      priceSettingRowHandler(rowData) {
        if (!rowData.chargeMethod || rowData.chargeMethod?.length == 0) {
          this.$message.error('请先选择计费方式');
          return;
        }
        if (!rowData.spaceArea || rowData.spaceArea?.length == 0) {
          this.$message.error('请先输入面积');
          return;
        }
        this.$refs.priceSetDialogRef.openModal(rowData);
      },
      // 免租设置
      settleRentFreeRowHandler(rowData) {
        console.log(this.leaseDateFrom, '表单数据', this.leaseDateUntil);
        console.log(rowData);
        this.editRowItem = rowData;
        if (!this.leaseDateFrom || !this.leaseDateUntil) {
          this.$message.warning('请补充租赁时间范围');
          return;
        }
        console.log(rowData, '????', rowData['leaseContractFreeRents']);
        this.$refs.settleRentFreeDialogRef.openModel(
          rowData,
          this.leaseDateFrom,
          this.leaseDateUntil
        );
      },
      settleRendFreeSubmitHandler(rowData) {
        console.log(rowData, '提交后的数据，需要替换当前编辑的行');
        const tableDataList = this.$refs.spaceTable.getTableData().fullData || [];
        const currentIndex = tableDataList.findIndex((item) => item._XID == rowData._XID);
        tableDataList.splice(currentIndex, 1, rowData);
        this.spaceTableData = tableDataList;
      },
      openInfoHandler() {
        this.$refs.firstSettlementDialogRef.openModal();
      },
      insertEvent() {
        console.log('insertEvent');
        this.$refs['spaceTable'].validate((valid) => {
          if (valid) {
            let record = {
              spaceAreaNo: '',
              spaceAssetNo: '',
              spaceUnitNo: '',
              spaceFloorNo: '',
              spaceRoomNo: '',
              spaceArea: '',
              chargeMethod: '',
              measurementUnit: '',
              chargeUnitPrice: '',
              expenseTypeCode: '',
              expenseTypeName: '',
              chargePrice: '',
              chargeCycle: '',
              rentAmount: '',
              firstSettlementDate: '',
              annualGrowthRate: '',
              spaceDetails: [],
            };
            this.$refs.spaceTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.spaceTable.setActiveRow(row));
          }
        });
      },
      // 计费单价变换后 租金计算
      handleChargePrice(val, row, scope, fieldName) {
        console.log(val, scope, row, '11111');
        if (fieldName == 'spaceArea' && val > row['spaceAreaSource']) {
          this.$message.warning(`当前输入面积不能大于${row['spaceAreaSource']}`);
          row['spaceArea'] = row['spaceAreaSource'];
          return;
        }
        if (!row.chargeMethod && fieldName != 'spaceArea') {
          this.$message({
            showClose: true,
            message: '请填写计费方式',
            type: 'warning',
          });
          return;
        }
        // // if (!row.chargeCycle) {
        // //   return this.$message({
        // //     showClose: true,
        // //     message: '请填写计费周期',
        // //     type: 'warning',
        // //   });
        // // }
        // if (!row.chargeUnitPrice) {
        //   return this.$message({
        //     showClose: true,
        //     message: '请填写计费单价',
        //     type: 'warning',
        //   });
        // }
        console.log(this.startDate, this.endDate, '11222');
        if (!this.startDate || !this.endDate) {
          return this.$message({
            showClose: true,
            message: '请填写租赁期限',
            type: 'warning',
          });
        }
        if (row.chargeMethod === '01') {
          row.chargePrice = (Number(row.spaceArea) * Number(row.chargeUnitPrice)).toFixed(3);
        } else {
          row.chargePrice = Number(row.chargeUnitPrice).toFixed(3);
        }

        this.$refs['spaceTable'].reloadRow(row);
        this.$refs['spaceTable'].updateStatus(scope);
        let rentAmount = 0;
        console.log(rentAmount);
        const mons = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function lastDay(mo, year) {
          if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
            return 30;
          }
          //2月
          else if (mo === 2) {
            if (isLeapYear(year)) {
              return 29;
            } else {
              return 28;
            }
          }
          //大月
          else {
            return 31;
          }
        }
        function isLeapYear(Year) {
          return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
        }
        function diff(startDate, endDate) {
          endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
          const date = new Date(startDate);
          const year = date.getFullYear(); // 取当年的年
          const month = date.getMonth() + 1; // 取当年的月(月份加一)
          const dd = date.getDate(); // 取当年的日期
          const nowDate = new Date(endDate); // 取现在的时间
          const nowYear = nowDate.getFullYear(); // 取现在的年
          const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
          const nowDd = nowDate.getDate(); // 取现在的日期
          const restDd = nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
          const restMonth = nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
          const restYear = nowYear - year;
          let resultMonth = restMonth;
          let resultYear = restYear;
          if (nowDd < dd) {
            resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
          }
          if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
            resultYear = restYear - 1;
          }
          return [resultYear, resultMonth, restDd];
        }
        console.log(diff(this.startDate, this.endDate), '1111');
        let arr = diff(this.startDate, this.endDate);
        let { chargeMethod, chargeCycle, chargePrice, spaceArea } = row;
        console.log(chargeCycle, spaceArea, 'chargeCycle');
        // let everyDayCost = (
        //   (chargePrice / mons[new Date(this.endDate).getMonth()]) *
        //   spaceArea
        // ).toFixed(2);
        let everyDayCost = (chargePrice / mons[new Date(this.endDate).getMonth()]).toFixed(2);
        let everyDayCostTwo = (chargePrice / mons[new Date(this.endDate).getMonth()]).toFixed(2);
        if (chargeMethod === '01') {
          // 平米
          // rentAmount = (
          //   chargePrice * spaceArea * arr[0] * 12 +
          //   chargePrice * spaceArea * arr[1] +
          //   everyDayCost * arr[2]
          // ).toFixed(2);
          // TODO 需要处理
          rentAmount = (
            chargePrice * arr[0] * 12 +
            chargePrice * arr[1] +
            everyDayCost * arr[2]
          ).toFixed(2);
        } else {
          // 固定价
          rentAmount = chargePrice * arr[0] * 12 + chargePrice * arr[1] + everyDayCostTwo * arr[2];
        }
        // row.rentAmount = rentAmount + '';
        // row.totalAmount = rentAmount + '';
        let fullData = this.$refs.spaceTable.getTableData().fullData || [];
        let totalRent = 0;
        if (fullData.length > 0) {
          // fullData.forEach((space) => {
          //   totalRent = totalRent + Number(space.rentAmount);
          // });
          this.$emit('updateTotalRentAmount', totalRent);
        }
      },

      async dealDetailData(list) {
        console.log(JSON.stringify(list), 'detailSpaceTableData');
        for (let item of list) {
          if (item.spaceAreaNo) {
            await this.getAssetsList(item);
          }
          if (item.spaceAssetNo) {
            await this.getUnitList(item);
          }
          if (item.spaceUnitNo) {
            await this.getSpaceFloorList(item);
          }
          if (item.spaceFloorNo) {
            await this.getRoomList(item);
          }
        }
        console.log(list, '11111');
        this.spaceTableData = list;
      },
      // 免租时 修改对应spaceId的租金
      updateChangeRentAmount(currSpaceId, freeRentStart, freeRentEnd) {
        const mons = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function lastDay(mo, year) {
          if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
            return 30;
          }
          //2月
          else if (mo === 2) {
            if (isLeapYear(year)) {
              return 29;
            } else {
              return 28;
            }
          }
          //大月
          else {
            return 31;
          }
        }
        function isLeapYear(Year) {
          return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
        }
        function diff(startDate, endDate) {
          endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
          const date = new Date(startDate);
          const year = date.getFullYear(); // 取当年的年
          const month = date.getMonth() + 1; // 取当年的月(月份加一)
          const dd = date.getDate(); // 取当年的日期
          const nowDate = new Date(endDate); // 取现在的时间
          const nowYear = nowDate.getFullYear(); // 取现在的年
          const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
          const nowDd = nowDate.getDate(); // 取现在的日期
          const restDd = nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
          const restMonth = nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
          const restYear = nowYear - year;
          let resultMonth = restMonth;
          let resultYear = restYear;
          if (nowDd < dd) {
            resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
          }
          if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
            resultYear = restYear - 1;
          }
          return [resultYear, resultMonth, restDd];
        }
        let arr = diff(freeRentStart, freeRentEnd);

        let fullData = this.$refs.spaceTable.getTableData().fullData || [];
        fullData.map((item) => {
          if (item.spaceId === currSpaceId) {
            item.rentAmount =
              (
                item.totalAmount -
                arr[0] * 12 * item.chargePrice -
                arr[1] * item.chargePrice -
                arr[2] * (item.chargePrice / mons[new Date(freeRentEnd).getMonth()]).toFixed(2)
              ).toFixed(2) || '';
            item.totalAmount =
              (
                item.totalAmount -
                arr[0] * 12 * item.chargePrice -
                arr[1] * item.chargePrice -
                arr[2] * (item.chargePrice / mons[new Date(freeRentEnd).getMonth()]).toFixed(2)
              ).toFixed(2) || 0;
          }
        });
        console.log(fullData, 'fullData');
        this.spaceTableData = fullData;
        // 并修改合同信息中的值
        let totalRent = 0;
        this.spaceTableData.forEach((space) => {
          totalRent = totalRent + Number(space.rentAmount);
        });
        this.$emit('updateTotalRentAmount', totalRent);
      },
      // 选择计费方式自动带出计量单位
      async handleChargeMethods(row, scope, tableType) {
        console.log('切换计费方式', row, scope, tableType);
        await this.$emit('changePayMethod', row);
        row.measurementUnit = '';
        row.chargeCycle = '';
        row.chargeUnitPrice = '';
        row.chargePrice = '';
        row.rentAmount = '';
        if (row.chargeMethod === '01') {
          row.measurementUnit = '01';
        } else {
          row.measurementUnit = '02';
        }
        this.$refs[tableType].reloadRow(row);
        this.$refs[tableType].updateStatus(scope);
      },
      getDataTable() {
        return (
          this.$refs.spaceTable.getTableData().fullData.map((item, index) => {
            return {
              ...item,
              rowIndex: index + 1,
            };
          }) || []
        );
      },
    },
    components: {
      SettleRentFreeDialog,
      PriceSetDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
